package org.matthewo.hooks

import js.coroutines.awaitCancellation
import react.useEffect
import web.html.HTMLElement
import web.mutation.MutationCallback
import web.mutation.MutationObserver
import web.mutation.MutationObserverInit

fun useObserver(
    element: HTMLElement?,
    attributes: Boolean = false,
    childList: Boolean = false,
    characterData: Boolean = false,
    subtree: Boolean = false,
    callback: MutationCallback,
) {
    useEffect(element) {
        if (element == null) return@useEffect

        val observer = MutationObserver(callback)

        observer.observe(
            element,
            MutationObserverInit(
                attributes = attributes,
                childList = childList,
                characterData = characterData,
                subtree = subtree,
            )
        )

        awaitCancellation { observer.disconnect() }
    }
}

fun useObserver(
    element: HTMLElement?,
    attributes: Boolean = false,
    childList: Boolean = false,
    characterData: Boolean = false,
    subtree: Boolean = false,
    callback: () -> Unit,
) {
    useObserver(element, attributes, childList, characterData, subtree) { _, _ -> callback() }
}
